import React from "react";
import { Link } from "react-router-dom";

const HeroOne = () => {
  return (
    <div
      className="hero-wrapper hero-1"
      id="hero"
      style={{ backgroundImage: "url(/assets/img/hero/hero_bg_1_1.png)" }}
    >
      <div className="container">
        <div className="row flex-row-reverse">
          <div className="col-xl-12">
            <div className="hero-style1">
              <span className="sub-title text-white">Tu Taller de Confianza en Sevilla</span>
              <h1 className="hero-title text-white">
                Reparación de Chapa, Pintura y Mecánica{" "}
                <span>
                  <img src="/assets/img/hero/hero_shape_1.png" alt="LEAL" />
                  con Garantía
                </span>{" "}
                de por Vida
              </h1>
              <p className="hero-text text-white">
                Más de 15 años devolviendo vehículos como nuevos. Presupuesto sin compromiso en 24 horas.
              </p>

              <div className="hero-trust-badges mt-4">
                <div className="trust-badge-inline">
                  <i className="fas fa-shield-alt text-white me-2"></i>
                  <span className="text-white">Garantía de por vida</span>
                </div>
                <div className="trust-badge-inline">
                  <i className="fas fa-trophy text-white me-2"></i>
                  <span className="text-white">+15 años experiencia</span>
                </div>
                <div className="trust-badge-inline">
                  <i className="fas fa-clock text-white me-2"></i>
                  <span className="text-white">Presupuesto en 24h</span>
                </div>
                <div className="trust-badge-inline">
                  <i className="fas fa-car text-white me-2"></i>
                  <span className="text-white">Vehículo de cortesía</span>
                </div>
              </div>
            </div>
          </div>
       
        </div>
      </div>
    </div>
  );
};

export default HeroOne;
